import React, { useMemo } from 'react';
import locales from '../../../content.json';
import { getParameterFromURL } from '../../../utils/scripts';
import { getRegionalCurrencyPrefix } from '../../../utils/scripts/currency';
import { Price } from '../pdfUpselling/components/price';
import { PriceV2 } from '../pdfUpselling/components/priceV2';
import PaymentModal from '../pdfUpselling/components/paymentModal';
import { SkipBtn } from '../pdfUpselling/components/skipBtn';
import { Logo } from '../logo';
import { Description } from './components/description';

import s from './index.module.scss';

import puppyGuideImage from './assets/guide-puppy.png';
import dogGuideImage from './assets/guide-dog.png';
import boostDogDot from './assets/boost-dog-dot.png';
import boostArrow from './assets/boost-arrow.png';

import stars from './assets/stars.png';
import twoX from './assets/twoX.png';
import icn1 from './assets/icn1.png';
import icn2 from './assets/icn2.png';
// import icn3 from './assets/icn3.png';
import icn4 from './assets/icn4.png';
import icn5 from './assets/icn5.png';
import icn6 from './assets/icn6.png';
import icn7 from './assets/icn7.png';
import icn8 from './assets/icn8.png';

const puppyBenefits = [
  {
    id: 'pdfUpselling_9',
    titleKey: 'pdfUpselling_9',
    description: 'payment_text_270',
    icon: icn1,
    style: {
      transform: 'rotate(-0.187deg)',
      background: 'var(--ed-brand, #AE66F6)',
    }
  },
  {
    id: 'pdfUpselling_10',
    titleKey: 'pdfUpselling_10',
    description: 'payment_text_271',
    icon: icn2,
    style: {
      transform: 'rotate(8.538deg)',
      background: '#F0930C',
    }
  },
  {
    id: 'pdfUpselling_11',
    titleKey: 'pdfUpselling_11',
    description: 'payment_text_272',
    icon: icn8,
    style: {
      transform: 'otate(-6.476deg)',
      background: '#29A073',
    }
  },
  {
    id: 'pdfUpselling_12',
    titleKey: 'pdfUpselling_12',
    description: 'payment_text_273',
    icon: icn4,
    style: {
      transform: 'rotate(13.33deg)',
      background: '#0E92F0',
    }
  },
];

const dogBenefits = [
  {
    id: 'pdfUpselling_5',
    titleKey: 'pdfUpselling_5',
    description: 'payment_text_274',
    icon: icn5,
    style: {
      transform: 'rotate(-0.187deg)',
      background: 'var(--ed-brand, #AE66F6)',
    }
  },
  {
    id: 'pdfUpselling_6',
    titleKey: 'pdfUpselling_6',
    description: 'payment_text_275',
    icon: icn6,
    style: {
      transform: 'rotate(8.538deg)',
      background: '#F0930C',
    }
  },
  {
    id: 'pdfUpselling_7',
    titleKey: 'pdfUpselling_7',
    description: 'payment_text_276',
    icon: icn7,
    style: {
      transform: 'rotate(-6.476deg)',
      background: '#29A073',
    }
  },
];

export const PDFUpsellingV1p20 = () => {
  const role = getParameterFromURL('role');
  const ppPDFV2 = getParameterFromURL('ppPDFV2');
  const paypalSuccessPayment = window.paypalPayment;
  const isPuppy = role === 'puppy';
  const isPriceV2 = Boolean(ppPDFV2 && paypalSuccessPayment);

  const title = useMemo(
    () => (isPuppy ? locales[window.userLang].payment_text_268 : locales[window.userLang].payment_text_269),
    [isPuppy]
  );

  const benefits = useMemo(() => (isPuppy ? puppyBenefits : dogBenefits), [isPuppy]);

  const currency = getRegionalCurrencyPrefix();

  const visualPrices = useMemo(
    () => ({
      oldPrice: isPriceV2 ? '43.46' : '66.64',
      discountPrice: isPriceV2 ? '42.47' : '46.64',
      totalPrice: isPriceV2 ? '0.99' : '19.99',
      discountLabel: isPriceV2 ? locales[window.userLang].payment_text_279 : locales[window.userLang].payment_text_280,
    }),
    [isPriceV2]
  );

  return (
    <section className={s.wrapper}>
      <Logo />

      <div className={s.content}>
        <div className={s.speedCard}>
          <img className={s.speedValue} src={twoX} alt="2x" />
          <p className={s.speedText} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_267 }} />
          <img className={s.speedIcn} src={stars} alt="stars" />
        </div>

        <h2 className={s.title}>{title}</h2>

        <div className={s.mainCard}>
          <img className={s.guideImage} src={isPuppy ? puppyGuideImage : dogGuideImage} alt="guide cover" />
          <div className={s.mainWrapper}>
            <Description />
            <ul className={s.benefitsCard}>
              {benefits.map((item) => (
                <li key={item.id} className={s.benefitRow}>
                  <div className={s.benefitIconWrap} style={ item.style }>
                    <img src={item.icon} alt={locales[window.userLang][item.titleKey]} />
                  </div>
                  <div className={s.benefitTextWrap}>
                    <p className={s.benefitTitle}>{locales[window.userLang][item.titleKey]}</p>
                    <p className={s.benefitDescription}>{locales[window.userLang][item.description]}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className={s.boostCard}>
              <p className={s.boostText} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_277 }} />
              <img className={s.boostDot} src={boostDogDot} alt="" aria-hidden="true" />
              <img className={s.boostArrow} src={boostArrow} alt="" aria-hidden="true" />
            </div>

            <div className={s.priceSummary}>
            <div className={s.priceRow}>
              <p className={s.priceLabel}>{locales[window.userLang].payment_text_278}</p>
              <p className={s.priceValue}>{currency}{visualPrices.oldPrice}</p>
            </div>
            <div className={s.priceRow}>
              <p className={s.priceLabel}>{visualPrices.discountLabel}:</p>
              <p className={s.discountValue}>-{currency}{visualPrices.discountPrice}</p>
            </div>
            <div className={s.separator} />
            <div className={s.totalRow}>
              <p className={s.totalLabel}>{locales[window.userLang].chatUpsaleV2_25}:</p>
              <p className={s.totalValue}>{currency}{visualPrices.totalPrice}</p>
            </div>
          </div>

          <div className={s.paymentModalBlock}>
            <PaymentModal />
          </div>

          <SkipBtn />

          </div>
        </div>

        <div className={s.logicPrice} aria-hidden="true">
          {isPriceV2 ? <PriceV2 /> : <Price />}
        </div>
      </div>
    </section>
  );
};
